<div class="mt-2 p-2 ">
    <form [formGroup]="EmailReplyForm">
        <div class="field">
            <label for="emailTo">To<span class="requiredField">*</span></label>
            <input id="emailTo" placeholder="Enter email ID" formControlName="to" pInputText type="text"
                class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
            <div
                *ngIf="(EmailReplyForm.get('to')?.invalid && EmailReplyForm.get('to')?.touched) || EmailReplyForm.get('to')?.dirty">
                <small class="p-error" *ngIf="EmailReplyForm.get('to')?.errors?.invalidEmails">Please provide a
                    valid Email Format</small>
                <small class="p-error" *ngIf="EmailReplyForm.get('to')?.errors?.forbiddenEmail">You cannot Reply
                    to Source Email Id</small>
                <small class="p-error" *ngIf="EmailReplyForm.get('to')?.errors?.required">Email To is
                    required</small>
            </div>
        </div>
        <div class="field">
            <label for="emailCC">CC</label>
            <input id="emailCC" placeholder="Enter email ID" formControlName="cc" pInputText type="text"
                class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
            <div
                *ngIf="(EmailReplyForm.get('cc')?.invalid && EmailReplyForm.get('cc')?.touched) || EmailReplyForm.get('cc')?.dirty">
                <small class="p-error" *ngIf="EmailReplyForm.get('cc')?.errors?.invalidEmails">Please provide a
                    valid Email Format</small>
                <small class="p-error" *ngIf="EmailReplyForm.get('cc')?.errors?.forbiddenEmail">You cannot
                    Reply/Forward to Source Email Id</small>
            </div>
        </div>
        <div class="field">
            <label for="lastname1">Subject<span class="requiredField"></span></label>
            <input id="lastname1" placeholder="Enter Subject" formControlName="subject" pInputText type="text" placeholder="Document Shared with You - Astro"
                class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
            <div
                *ngIf="(EmailReplyForm.get('subject')?.invalid && EmailReplyForm.get('subject')?.touched) || EmailReplyForm.get('subject')?.dirty">
                <small class="p-error" *ngIf="EmailReplyForm.get('subject')?.errors?.required">Email Subject is
                    required</small>
            </div>
        </div>
        <div class="field">
            <label for="lastname1">Message<span class="requiredField"></span></label>
            <p-editor formControlName="body" placeholder="Please find the shared documents at the following links:" [modules]="editorModules" [style]="{ height: '100px' }"></p-editor>
            <small *ngIf="EmailReplyForm.get('body').touched && EmailReplyForm.get('body')?.invalid"
                class="p-error">Message cannot be empty.</small>
            </div>
    </form>
        <div class="md:col-12 flex justify-content-center">
            <button pButton type="button" label="CANCEL" class="cozmos-secondary-button"
                (click)="resetReplyForm()"></button>
            <button pButton type="button" label="SEND" class=" ml-2 cozmos-primary-button"
                [disabled]="!EmailReplyForm.valid" (click)="onClickSend()"></button>
        </div>
</div>